<template>
  <div>
    <div>
      <b-badge variant="danger">
        Kurumsal Müşteri
      </b-badge>
      <b-badge
        variant="warning"
        @click="isEditing=true"
      >
        Düzenle
      </b-badge>
    </div>

    <div v-if="isEditing">
      <b-row>
        <b-col md="12">
          <b-form-input
            v-model="customer.invoice_tax_number"
            class="pl-1 pr-2"
            size="sm"
            placeholder="Vergi Numarası"
          />
          <b-form-input
            v-model="customer.invoice_tax_office"
            class="pl-1 pr-2"
            size="sm"
            placeholder="Vergi Dairesi"
          />
          <b-form-textarea
            v-model="customer.invoice_address1"
            class="pl-1 pr-2"
            size="sm"
            placeholder="Fatura Adresi"
          />
          <b-button
            size="sm"
            @click="saveEdit"
          >
            Kaydet
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <b-row>
        <b-col md="12">
          VN: <b>{{ customer.invoice_tax_number }}</b>
          <feather-icon
            v-if="customer.invoice_tax_number"
            icon="CopyIcon"
            @click="doCopy(customer.invoice_tax_number)"
          />
        </b-col>
        <b-col md="12">
          VD: <b>{{ customer.invoice_tax_office }}</b>
          <feather-icon
            v-if="customer.invoice_tax_office"
            icon="CopyIcon"
            @click="doCopy(customer.invoice_tax_office)"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import copyMixins from '@/mixins/copyMixins'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'OrderCommercialCustomer',
  mixins: [copyMixins],
  props: {
    order: {
      type: Object,
      required: true,
    },
    customer: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isEditing: false,
  }),
  methods: {
    saveEdit() {
      this.$store.dispatch('order/updateOrderCustomer', this.customer)
        .then(res => {
          this.$toast({
            component: ToastificationContent,
            props: res,
          })
          this.isEditing = false
        })
    },
  },
}
</script>

<style scoped>
</style>
